export const PAGE_VISUALIZER = {
  INICIO: 'inicio',
  AGREGAR: 'agregar',
  // agregar más valores aquí si es necesario
};

export const PARAM_CONFIG = {
  ROOT_PARAM_RECAUDO: 'PARAM_RECAUDO',
  NODE_RECAUDO_DIAS_TOLERANCIA: 'DIAS_TOLERANCIA',
  // agregar más valores aquí si es necesario
};

export const moduloConciliacion = {
  agGrid: {
    paginacion: 15,
    id: 'myGrid',
    // class: 'ag-theme-material mt-3',
    class: 'ag-theme-alpine mt-3',
    style: {
      width: '100%',
      height: '700px'
    }
  },
  url: {
    datosMaestros: {
      viaPago: 'via-pago',
      cliente: 'cliente/',
    },
    cobrosAutoservicios: {
      // http://172.25.4.31:8084/qrks/v1/financiero/api/service/cobros-autoserv/recaudacion/cliente-vinculado'
      // http://172.25.4.31:8084/qrks/v1/financiero/api/service/cobros-autoserv/recaudacion/cliente-vinculado/1001099
      cobrosAutoservicios: 'cobros-autoserv/',
      paramCobrosAutoserv: 'param',
      recaudacionCliente: 'recaudacion/',
      clienteVinculado: 'cliente-vinculado?idCliente=',
      uploadFile: 'uploadFile',
      processData: 'processData',
      saveCollection: 'saveCollection',
      getAutoServCabe: 'cabecera',
      findCobrosAutoServDeta: 'detalle/',
      getPDF: 'getPDF/',
    },
    conciliacionBancaria: {
      conciBanc: 'conci-banc/param-conci-banca/finClaveBanco',
    },
    parametros: {
      idParametro: '?idParam=',
      idCliente: '?idCliente=',
      idEmpresa: '?idEmpresa=',
      idBanco: '&idBanco='
    },
    seguridadPrueba: ''
  },
  button: {
    buttonsCss: {
      primary: 'btn btn-primary btn-block',
      secondary: 'btn btn-secondary btn-block',
      success: 'btn btn-success btn-block',
      danger: 'btn btn-danger btn-block',
      warning: 'btn btn-warning btn-block',
      info: 'btn btn-info btn-block',
      light: 'btn btn-light btn-block',
      dark: 'btn btn-dark btn-block',
      warningFile: 'btn btn-warning btn-block',
      primaryOutline: 'btn btn-outline-primary',
      secondaryOutline: 'btn btn-outline-secondary',
      successOutline: 'btn btn-outline-success',
      dangerOutline: 'btn btn-outline-danger',
      warningOutline: 'btn btn-outline-warning',
      infoOutline: 'btn btn-outline-info',
      lightOutline: 'btn btn-outline-light',
      darkOutline: 'btn btn-outline-dark',
      primarylg: 'btn btn-primary btn-lg btn-block',
      successLg: 'btn btn-success btn-lg btn-block',
      dangerLg: 'btn btn-outline-danger btn-lg btn-block',
      warningLg: 'btn btn-warning btn-lg btn-block',
      warningLgFile: 'btn btn-warning btn-lg btn-block btn-file',
    },
    buttonsNombre: {
      editar: 'Editar',
      ver: 'Ver',
      eliminar: 'Eliminar',
      agregar: 'Agregar ',
      guardar: 'Guardar',
      actualizar: 'Actualizar',
      mostrar: 'Mostrar seleccion',
      regresar: 'Regresar',
      continuar: 'Continuar',
      seleccionar: 'Seleccionar',
      procesar: 'Procesar',
      sustento: 'Sustento',
      validar: 'Validar',
      descargar: 'Descargar',
      descargarRecibo: 'Descargar Recibo Cobros',
      descargarEstado: 'Descargar Estados Docs'
    }
  },
  mensajes: {
    errorServicio: 'error..!!',
    desabilitada: 'Opción desabilitada',
    eliminar: '¿Esta seguro que desea eliminar el siguiente elemento?',
    guardar: '¿Esta seguro que desea guardar el siguiente elemento?',
    actualizar: '¿Esta seguro que desea actualizar el siguiente elemento?',
    datoGuardado: 'Se guardo corectamente..!!',
    guardarParada: 'Esta seguro que desea registrar este evento..??',
    procesar: '¿Esta seguro que desea procesar el siguiente elemento?',
    validar: '¿Esta seguro que desea validar el siguiente elemento?',
    anticipo: 'Se tomara este valor como anticipo.',
    camposObligatorio: 'Los campos tipo transaccion y número documento deben estar llenos caso contrario se tomara como anticipo.',
  }

}
